import { render } from "./FilterMarca.vue?vue&type=template&id=d2fa4dca"
import script from "./FilterMarca.vue?vue&type=script&lang=js"
export * from "./FilterMarca.vue?vue&type=script&lang=js"

import "./FilterMarca.vue?vue&type=style&index=0&id=d2fa4dca&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__